import React from 'react';
import { Pressable } from 'react-native';
import { PaperPlaneTilt } from '@phosphor-icons/react';
import { useNavigation, useNavigationState } from '@react-navigation/core';

import { Colors } from '@theme';

import { styles } from './styles';

export const ChatButton = (): JSX.Element => {
  const navigation = useNavigation();
  const state = useNavigationState((navigationState) => navigationState);
  const isChatRoute = state.routes[state.index]?.name === 'Chat';

  const handlePress = () => {
    navigation.navigate('Chat');
  };

  return (
    <Pressable
      hitSlop={20}
      style={[styles.chatButton, isChatRoute && styles.chatActiveButton]}
      onPress={handlePress}>
      <PaperPlaneTilt size={24} color={isChatRoute ? Colors.limeGreen : '#A4ADC2'} />
    </Pressable>
  );
};
